module.exports = __webpack_public_path__ + "static/media/LLBetter.b7300192.jpg";